import * as faceapi from 'face-api.js';
import smartcrop from 'smartcrop';

class BackgroundImageCropService {
  constructor(el) {
    this.el = el;
    this.img = new Image();
  }

  setBackgroundProperties() {
    this.img.crossOrigin = 'anonymous';
    const timestamp = new Date().getTime();
    this.img.src = `${this.extractImageUrl(
      this.el.style.backgroundImage
    )}?v=${timestamp}`;
    this.img.onload = () => {
      this.handleFacesOrSmartCrop();
    };
  }

  extractImageUrl(backgroundImage) {
    return backgroundImage.slice(4, -1).replace(/["']/g, '');
  }

  handleFacesOrSmartCrop() {
    faceapi.detectAllFaces(this.img).then((detections) => {
      if (detections.length) {
        this.positionImageToShowFaces(detections);
      } else {
        this.applySmartCrop();
      }
    });
  }

  positionImageToShowFaces(detections) {
    const { x, y, width, height } = detections[0].box;
    const centerX = ((x + width / 2) / this.img.naturalWidth) * 100;
    const centerY = ((y + height / 2) / this.img.naturalHeight) * 100;
    this.el.style.backgroundSize = 'cover';
    this.el.style.backgroundPosition = `${centerX}% ${centerY}%`;
  }

  applySmartCrop() {
    smartcrop
      .crop(this.img, {
        width: this.el.clientWidth,
        height: this.el.clientHeight,
      })
      .then((result) => {
        const crop = result.topCrop;
        const scale = this.el.clientWidth / crop.width;
        const bgWidth = this.img.naturalWidth * scale;
        const bgHeight = this.img.naturalHeight * scale;
        this.el.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;

        const offsetX = crop.x * scale;
        const offsetY = crop.y * scale;
        this.el.style.backgroundPosition = `-${offsetX}px -${offsetY}px`;
      });
  }
}

export default BackgroundImageCropService;
